import { ModuleError } from './module.error'
import { ModuleRegExp } from './module.regexp'

const Module = {
  Error: ModuleError,
  RegExp: ModuleRegExp,
}

export default Module